import { Link } from "react-router-dom";
import { AppIcon } from "@/components/Brand";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#1E1E1E] text-white flex items-center justify-center px-5">
      <div className="max-w-lg w-full text-center" data-testid="payment-cancel-page">
        <span className="inline-grid place-items-center w-20 h-20 rounded-[1.4rem] bg-[#2BBFB3]/15 border border-[#2BBFB3]/30">
          <AppIcon size={48} />
        </span>
        <XCircle size={44} className="mx-auto mt-8 text-white/40" />
        <h1 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl">Checkout cancelled.</h1>
        <p className="mt-3 text-white/60">
          No charge was made. You can pick a plan whenever you're ready — the Founding Instructor price is
          locked for life while spots remain.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="/#pricing"
            data-testid="payment-cancel-pricing"
            className="inline-flex items-center justify-center rounded-full bg-[#2BBFB3] px-6 py-3 text-sm font-semibold text-[#0f1211] hover:bg-[#1FA097] transition-colors"
          >
            Back to plans
          </a>
          <Link
            to="/"
            data-testid="payment-cancel-home"
            className="inline-flex items-center justify-center rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white hover:bg-white/10 transition-colors"
          >
            Back to DriveAssure
          </Link>
        </div>
      </div>
    </div>
  );
}
